module.exports = __webpack_public_path__ + "img/1465389772.64b6d495.jpg";